<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202503_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202503_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>スキンケアの基本が美肌への近道！</span><br>化粧水・乳液・美容液の正しい使い方と順番</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="my-5 py-5">
      <h2 class="mt-5 mb-3 text-left">化粧水・乳液・美容液、なんとなく使っていませんか？</h2>
      <p class="mb-3">「化粧水と美容液って何が違うの？」「乳液って使わないとダメ？」</p>
      <p class="mb-3">そんな風に、スキンケアをなんとなく自己流で続けている方は意外と多いものです。</p>
      <p class="mb-3">しかし、化粧水・美容液・乳液にはそれぞれ異なる役割があり、使う順番や方法によって効果に大きな差が出ます。</p>
      <p class="mb-3">肌に必要なケアを、正しく、無理なく取り入れることが、美肌への近道になります。</p>
      <p class="mb-3">この記事では、スキンケアの基本ステップとともに、化粧水・美容液・乳液の役割や選び方を丁寧に解説します。</p>
      <p>毎日のスキンケアに自信が持てるよう、今すぐ見直してみましょう。</p>
    </div>
    <div class="toc mb-5 pb-5">
      <h3>もくじ</h3>
      <ul>
        <li><a @click="scrollToAnchorPoint('section-step')">スキンケアの基本ステップと正しい順番</a></li>
        <li><a @click="scrollToAnchorPoint('section-lotion')">化粧水の役割とは？肌に水分を与えて整える“土台作り”</a></li>
        <li><a @click="scrollToAnchorPoint('section-serum')">美容液の役割と選び方｜肌悩みに合わせた集中ケア</a></li>
        <li><a @click="scrollToAnchorPoint('section-moisture')">乳液とクリームの違いと役割｜スキンケアの仕上げは保湿の“ふた”</a></li>
        <li><a @click="scrollToAnchorPoint('section-plus')">＋αのスキンケア｜美肌に近づく「ちょい足し」テクニック</a></li>
        <li><a @click="scrollToAnchorPoint('section-understand')">スキンケアの基本を理解して美肌を育てよう</a></li>
      </ul>
    </div>
    <div class="feature-row pt-5 mt-5" ref="section-step">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202503_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">スキンケアの基本ステップと正しい順番</h3>
        <p class="mb-3">正しいスキンケアの順番は「洗顔 → （導入美容液） → 化粧水 → 美容液 → 乳液またはクリーム」です。洗顔直後に、化粧水の浸透を後押ししてくれるブースターの役割を果たす導入美容液を使うこともおすすめ。</p>
        <p class="mb-3">これらは肌の構造に基づいており、それぞれの役割を最大限に発揮するための基本となります。</p>
        <p class="mb-3">化粧水で肌をやわらかくし、水分を与えたあと、美容液で集中ケア。最後に乳液やクリームでうるおいを閉じ込めて、バリア機能を保ちます</p>
        <p>スキンケアの基本を理解し、正しい順番でケアを行うことが、美肌を保つための重要なポイントです。</p>
      </div>
    </div>

    <div ref="section-lotion">
      <h3 class="mb-3">化粧水の役割とは？肌に水分を与えて整える“土台作り”</h3>
      <p class="mb-3">化粧水は、洗顔後の肌に水分を補給し、美容成分を受け入れやすい状態に整えるスキンケアの土台です。乾燥を防ぐだけでなく、次に使う美容液の効果を高める導入の役割も担います。</p>
      <p class="mb-3">【化粧水の選び方のポイント】<br>
      ・乾燥肌：ヒアルロン酸やセラミド入りで保湿力が高いもの<br>
      ・脂性肌：収れん作用のあるさっぱりタイプ<br>
      ・敏感肌：アルコールフリー、無香料など低刺激設計</p>
      <p>【化粧水の使い方】<br>
      化粧水はコットンまたは手のひらで優しく肌に押し込むようになじませましょう。複数回に分けて重ねづけすることで、よりうるおいが浸透しやすくなります。</p>
    </div>

    <div class="mt-5 pt-5" ref="section-serum">
      <h3 class="mb-3">美容液の役割と選び方｜肌悩みに合わせた集中ケア</h3>
      <p class="mb-3">美容液は、肌悩みにピンポイントでアプローチする集中ケアアイテムです。美白、エイジングケア、毛穴対策、乾燥対策など、それぞれの目的に合わせた成分が高濃度で配合されています。</p>
      <p class="mb-3">スキンケアの中でも「投資する価値がある」と言われるのは、美容液の効果実感が得られやすいから。肌悩みが気になる方は、化粧水と美容液の見直しから始めてみるとよいでしょう。</p>
      <p class="mb-3">【美容液の選び方】<br>
      ・美白ケア：ビタミンC誘導体、トラネキサム酸<br>
      ・エイジングケア：レチノール、ナイアシンアミド、ペプチド<br>
      ・毛穴・皮脂ケア：グリコール酸、サリチル酸、ビタミンB6</p>
      <p>【使い方のポイント】<br>
      化粧水の後、肌がしっとりしているうちに美容液をなじませるのがベストです。肌の奥（角質層）まで成分を届けるよう、指の腹で優しくプレスするのがコツです。</p>
    </div>

    <div class="mt-5 pt-5" ref="section-moisture">
      <h3 class="mb-3">乳液とクリームの違いと役割｜スキンケアの仕上げは保湿の“ふた”</h3>
      <p class="mb-3">乳液とクリームは、肌にふたをして水分の蒸発を防ぐ保湿アイテムです。化粧水や美容液で与えたうるおいを閉じ込め、肌のバリア機能をサポートします。</p>
      <p class="mb-3">「乳液とクリーム、どちらを使えばいい？」と迷う方も多いですが、肌質や季節によって使い分けるのがおすすめです。</p>
      <p class="mb-3">【乳液とクリームの違い】<br>
      ・乳液：水分と油分のバランスが取れた、みずみずしい保湿剤。軽い仕上がり。 ・クリーム：油分が多く、乾燥が気になるときに適したリッチな保湿剤。</p>
      <p>【おすすめの使い分け】<br>
      ・春夏：乳液中心で軽やかな保湿を ・秋冬：クリームでしっかり保湿＋保護 ・インナードライ肌：乳液とクリームの重ね使いでバランスを</p>
    </div>

    <div class="mt-5 pt-5" ref="section-plus">
      <h3 class="mb-3">＋αのスキンケア｜美肌に近づく「ちょい足し」テクニック</h3>
      <p class="mb-3">「いつものスキンケアでは物足りない」「もっと肌を育てたい」という方には、＋αのスペシャルケアがおすすめです。</p>
      <p class="mb-3">アイテムを賢く取り入れることで、肌の変化を感じやすくなります。</p>
      <p class="mb-3">【おすすめのちょい足しアイテム】<br>
      ・ブースター美容液（導入美容液）：化粧水の前に使って浸透力を高める<br>
      ・美容オイル：肌のうるおい保持力をアップ。ナイトケアにも◎<br>
      ・美顔器：リフトアップや毛穴引き締めをサポート</p>
      <p>【美肌を育てるゴールデンタイム】<br>
      夜の22時〜2時は“肌のゴールデンタイム”とも言われ、再生が最も活発な時間帯です。夜のスキンケアこそ丁寧に取り組むことで、翌朝の肌に差がつきます。</p>
    </div>

    <div class="mt-5 py-5" ref="section-understand">
      <h3 class="text-center">FAQs</h3>
      <dl class="list-qa">
        <dt v-on:click="openInfo('1')" :class="{'is-active': isActive[1]}">スキンケアは何を使えばいい？最低限必要なアイテムは？</dt>
        <dd v-show="isActive[1]">
          <p class="mb-3">スキンケア初心者の方や時間がない方にとって、「何から使えばいいのか分からない」という声は多く聞かれます。</p>
          <p class="mb-3">最低限必要なのは、「化粧水」と「保湿剤（乳液またはクリーム）」の2つです。<br>さらに、肌悩み（毛穴・くすみ・乾燥）を感じている方は、「美容液」をプラスすることで、スキンケア効果を実感しやすくなります。</p>
          <p>例：時短で済ませたい朝 → 化粧水＋乳液<br>例：肌荒れや毛穴が気になる夜 → 化粧水＋美容液＋クリーム</p>
        </dd>
        <dt v-on:click="openInfo('2')" :class="{'is-active': isActive[2]}">朝のスキンケアに美容液は必要？使うタイミングと選び方</dt>
        <dd v-show="isActive[2]">
          <p class="mb-3">「朝のスキンケアに美容液を使うべきか？」という疑問は非常に多い検索トピックです。</p>
          <p class="mb-3">結論として、朝も美容液を使うことで、日中の紫外線や乾燥から肌を守ることができます。特に、ビタミンC誘導体やナイアシンアミドを配合した美容液は、肌のトーンアップやくすみケアにも効果的です。</p>
          <p class="mb-3">朝のスキンケアにおすすめの美容液は、以下のような軽めのテクスチャーがおすすめです。</p>
          <ul class="list-dot-01 mb-3">
            <li>ビタミンC美容液（紫外線対策＋くすみ予防）</li>
            <li>ヒアルロン酸配合美容液（ハリ・乾燥対策）</li>
          </ul>
          <p>美容液は「化粧水の後」に使いましょう。</p>
        </dd>
        <dt v-on:click="openInfo('3')" :class="{'is-active': isActive[3]}">スキンケアは年代によって変えるべき？20代と40代の違い</dt>
        <dd v-show="isActive[3]">
           <p class="mb-3">「20代と40代でスキンケア方法はどう違うの？」という質問は、世代ごとの肌悩みに直結したSEOワードです。</p>
           <p class="mb-3">スキンケアは年代に応じて内容を見直すことがとても重要です。</p>
           <p class="mb-3"><strong>20代のスキンケアポイント：</strong><br>・生活習慣の乱れによる乾燥やニキビに注意<br>・基本の保湿＋UV対策を重視<br>・シンプルなケアでもOK</p>
           <p class="mb-3"><strong>30代以降〜40代のスキンケアポイント：</strong><br>・ハリ不足、たるみ、くすみが気になり始める<br>・美容液やアイクリームなどの「エイジングケアアイテム」を取り入れる<br>・週1〜2回のスペシャルケアで肌を立て直すことも◎</p>
           <p>肌の変化に合わせて成分や使用量を調整することが、長く美肌を保つカギとなります。</p>
        </dd>
        <dt v-on:click="openInfo('4')" :class="{'is-active': isActive[4]}">スキンケアの順番を間違えると効果がなくなる？</dt>
        <dd v-show="isActive[4]">
          <p class="mb-3">スキンケアの順番は「肌への吸収効率」に大きく影響します。間違った順番で使うと、本来の効果が十分に発揮されない場合もあります。</p>
          <p class="mb-3">正しい基本ステップは以下の通りです：</p>
          <ol class="list-dec-01 mb-3">
            <li>洗顔（不要な汚れを落とす）</li>
            <li>化粧水（肌をやわらかく整える）</li>
            <li>美容液（集中ケア）</li>
            <li>乳液 or クリーム（保湿とバリア）</li>
          </ol>
          <p>特に、美容液→化粧水のように順番を逆にしてしまうと、美容成分が肌に入りにくくなる恐れがあります。スキンケアの効果を最大化するには、基本の順番を守ることが大切です。</p>
        </dd>
        <dt v-on:click="openInfo('5')" :class="{'is-active': isActive[5]}">スキンケアが面倒な日はどうすればいい？時短でもできるケア方法は？</dt>
        <dd v-show="isActive[5]">
          <p class="mb-3">忙しい朝や疲れた夜、フルラインでのスキンケアが難しい日もあるでしょう。そんな時でも、肌を守るために最低限のステップは押さえましょう。</p>
          <p class="mb-3">おすすめの時短スキンケア例：</p>
          <ul class="list-dot-01 mb-3">
            <li>化粧水＋保湿クリームだけでもOK</li>
            <li>スプレータイプのミスト化粧水を常備</li>
          </ul>
          <p>「完璧を目指さず、最低限保湿をする」ことが肌を守るコツです。<br>できる日とできない日で、柔軟にスキンケアを切り替えるスタイルも今の時代に合った美肌習慣といえます。</p>
        </dd>
      </dl>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">スキンケアの基本を理解して美肌を育てよう</p>
        <p class="mb-3">スキンケアは、「なんとなく続けるもの」ではなく、肌に必要なことを正しく届ける“戦略的なケア”へと進化しています。</p>
        <p class="mb-3">化粧水・美容液・乳液それぞれの役割を知り、肌質や年齢、季節に合わせて正しく使うことで、肌本来の力を引き出すことができます。</p>
        <p class="mb-3">「肌は変わらない」とあきらめる前に、スキンケアの基本と使い方を一度見直してみることが、美肌への第一歩です。</p>
        <p>あなたの肌に合ったスキンケアを、今日から始めてみませんか？</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
    width: 100%;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
.toc {
  max-width: 600px;
  margin: 0 auto;
  border: 2px solid #e6c87a;
  padding: 20px;
}
.toc h3 {
  border-bottom: 1px solid #e6c87a;
  margin-bottom: 10px;
}
.toc ul li {
  margin-bottom: 5px;
}
.toc ul li a {
  color: #333;
  border-bottom: 1px dotted #e6c87a;
  padding-bottom: 5px;
  display: inline-block;
}
.toc ul li a:hover {
  color: #e6c87a;
  border-bottom: 2px solid;
  cursor: pointer;
}

@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 10; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = !this.isActive[ref]
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>